import React, { useEffect, useState } from "react";
import {
  Typography,
  Row,
  Col,
  Breadcrumb,
  Input,
  Collapse,
  Checkbox,
  Divider,
  Pagination,
  Select,
  Image,
} from "antd";
import { AppFooter } from "../LandingPage/Components/Footer/Footer";
import LogoGallery from "../LandingPage/Components/Logo/Logos";
import { useNotification } from "~/Hooks/useNotification";
import axios from "axios";
import type { MenuProps } from "antd";
import type { PaginationProps } from "antd";
import InvestImg from "@assets/KPMG/Invest.png";
import { PlusOutlined, MinusOutlined } from "@ant-design/icons";
import MainHeader from "../../Components/MainHeader/MainHeader";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { PooledFinancingData } from "./mock";
import { FinancingCard } from "./ProductCard";
import DjuandaWater from "@assets/KPMG/assets/DjuandaWater.png";
import BinhDuong from "@assets/KPMG/assets/BinhDuong.png";
import plant from "@assets/KPMG/assets/plant.png";
import reserve from "@assets/KPMG/assets/reserve.png";
import { Icon } from "@iconify/react";
import { ProjectsCard } from "~/Components/ProjectsCard/ProjectsCard";
import { useMaskId } from "~/Hooks/useMaskId";
import { NoData } from "../InfratechMarketPlace/Components/NoData";
import AIIB from "@assets/KPMG/FinancingProducts/AIIB.png";
import World from "@assets/KPMG/FinancingProducts/World.png";
import ADB from "@assets/KPMG/FinancingProducts/Adb.png";
import { InvestmentHubData } from "~/mocks/MockData";

const { Panel } = Collapse;
export const FinancingProducts: React.FC = () => {
  const { openToast } = useNotification();
  const [data, setData] = useState<any>([]);
  const [filteredData, setFilteredData] = useState<any>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(9);
  const [selectedCategories, setSelectedCategories] = useState<string[]>([]);
  const [selectedAreas, setSelectedAreas] = useState<string[]>([]);
  const [selectedCommercial, setSelectedCommercial] = useState<string[]>([]);
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const param = searchParams.get("q");
  const type = searchParams.get("type");
  const sectorParam = searchParams.get("sector");
  const { unmask } = useMaskId();
  const sectorList: any = ["ADB", "AFD", "AIIB", "KfW", "World Bank Group"];
  const commercialFinance = ["AFD", "KfW"];
  const areaList: any = [
    "ASEAN",
    "Thailand",
    "Malaysia",
    "Indonesia",
    "Singapore",
    "Philippines",
    "Myanmar",
    "Vietnam",
    "Cambodia",
    "Laos",
    "Brunei Darussalam",
  ];

  //   useEffect(() => {
  //     // if (param?.toString()) {
  //     //   const category = unmask(param?.toString());
  //     //   handleCategoryChange(category);
  //     // }
  //   }, [param]);
  //   useEffect(() => {
  //     if (countryParam) {
  //       setSelectedAreas([countryParam]);
  //       updateFilterData([], [countryParam]);
  //     } else {
  //       setFilteredData(InvestmentHubData);
  //     }
  //   }, [countryParam]);

  //   useEffect(() => {
  //     if (sectorParam) {
  //       setSelectedCategories([sectorParam]);
  //       updateFilterData([sectorParam], []);
  //     } else {
  //       setFilteredData(InvestmentHubData);
  //     }
  //   }, [sectorParam]);

  useEffect(() => {
    getRecords();
  }, []);

  const handlePageChange = (page: number, pageSize?: number) => {
    setCurrentPage(page);
    setPageSize(pageSize || 9);
  };

  useEffect(() => {
    if (type) {
      // setSelectedAreas([countryParam]);
      // updateFilterData([], [countryParam]);
      let provider = [];
      let tempData = [...PooledFinancingData];
      tempData = tempData.filter((item: any) => item.type === type);
      const providers: string[] = [];
      tempData.forEach((item) => {
        if (!providers.includes(item.provider)) {
          providers.push(item.provider);
        }
      });
      if (type == "Commercial Finance") {
        setSelectedCommercial(providers);
      } else {
        setSelectedCategories(providers);
      }

      setFilteredData(tempData);
    }
  }, [type]);

  const getRecords = async () => {
    setData(PooledFinancingData);
    setFilteredData(PooledFinancingData);
  };

  const handleMenuClick: MenuProps["onClick"] = (e) => {
    console.log("click", e);
  };

  const updateSector = (sector: string) => {
    let temp = [...selectedCategories];
    if (temp.includes(sector)) {
      temp = temp.filter((cat) => cat !== sector);
    } else {
      temp = [...temp, sector];
    }
    setSelectedCategories(temp);
    updateFilterData(temp, selectedCommercial);
  };

  const updateArea = (area: string) => {
    // let temp = [...selectedAreas];
    // if (temp.includes(area)) {
    //   temp = temp.filter((cat) => cat !== area);
    // } else {
    //   temp = [...temp, area];
    // }
    // setSelectedAreas(temp);
    // updateFilterData(selectedCategories, temp);
  };

  const updateCommercialFinance = (finance: string) => {
    let temp = [...selectedCommercial];
    if (temp.includes(finance)) {
      temp = temp.filter((cat) => cat !== finance);
    } else {
      temp = [...temp, finance];
    }

    setSelectedCommercial(temp);
    updateFilterData(selectedCategories, temp);
  };
  const updateFilterData = (concessional: any, commercial: any) => {
    let tempData = [...PooledFinancingData];
    if (!(concessional.length > 0 && commercial.length > 0)) {
      if (commercial.length > 0) {
        tempData = tempData.filter(
          (item: any) =>
            commercial.includes(item.provider) &&
            item.type == "Commercial Finance"
        );
      }
      if (concessional.length > 0) {
        tempData = tempData.filter(
          (item: any) =>
            concessional.includes(item.provider) &&
            item.type == "Concessional Finance"
        );
      }
    } else {
      tempData = tempData.filter(
        (item: any) =>
          (concessional.includes(item.provider) &&
            item.type === "Commercial Finance") ||
          (commercial.includes(item.provider) &&
            item.type === "Concessional Finance")
      );
    }

    setFilteredData(tempData);
  };

  const onSearch = (value: string) => {};

  return (
    <>
      <MainHeader
        title={"FINANCING PRODUCTS AND FRAMEWORKS"}
        imageSrc={InvestImg}
        text={
          "A hub to support and engage investors and infra owners/developers across sectors to access impact funds digitally. The decarb projects hub will offer investors access to project data and generate investible project names."
        }
      />
      <Row justify="center" style={{ backgroundColor: "#fff" }}>
        <Col lg={18} style={{ margin: "1.5rem 0 0 0" }} offset={2}>
          <Breadcrumb>
            <Breadcrumb.Item>
              <Icon
                icon="ic:outline-home"
                height="20"
                onClick={() => navigate("/")}
                style={{
                  margin: "auto",
                  color: "#ef406a",
                  cursor: "pointer",
                }}
              />
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <a onClick={() => navigate("/financing-products")}>
                Financing Products and Frameworks
              </a>
            </Breadcrumb.Item>
          </Breadcrumb>
        </Col>
        <Col lg={18} style={{ padding: "20px 0" }}>
          <Row gutter={16}>
            <Col lg={6}>
              <div className="listview-input">
                <Input
                  placeholder="Search"
                  style={{ width: "95%", borderRadius: "0.5rem" }}
                  onChange={(e) => {
                    onSearch(e.target.value);
                  }}
                />
                <div>
                  <Collapse
                    bordered={false}
                    defaultActiveKey={["concessionalFinance", "commercialFinancing", "others"]}
                    expandIcon={({ isActive }) =>
                      isActive ? <MinusOutlined /> : <PlusOutlined />
                    }
                    expandIconPosition="end"
                    style={{ background: "#fff" }}
                  >
                    <Panel
                      header={"Multinational Development Banks"}
                      key={"concessionalFinance"}
                    >
                      {sectorList.map((sector: any, index: number) => (
                        <div>
                          <Checkbox
                            key={index}
                            checked={selectedCategories.includes(sector)}
                            onChange={(e) => {
                              if (e) {
                                updateSector(sector);
                              }
                            }}
                          >
                            {sector}
                          </Checkbox>
                        </div>
                      ))}
                    </Panel>
                    <Panel
                      header={"Commercial Financing"}
                      key={"commercialFinancing"}
                    >
                      <div>
                        <Typography.Text>No Data</Typography.Text>
                      </div>
                    </Panel>
                    <Panel header={"Others"} key={"others"}>
                      <div>
                        <Typography.Text>No Data</Typography.Text>
                      </div>
                    </Panel>
                  </Collapse>
                </div>
              </div>
            </Col>
            <Col lg={18}>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Typography.Title level={4}>Projects</Typography.Title>
                {/* <Space className="invest-sort-button">
                  Sort By
                  <Dropdown menu={menuProps}>
                    <Button>
                      <Space>
                        Location &nbsp;&nbsp;
                        <DownOutlined />
                      </Space>
                    </Button>
                  </Dropdown>
                </Space> */}
              </div>
              {filteredData.length === 0 && (
                <Row gutter={[16, 16]} style={{ marginTop: 20 }}>
                  <Col span={24}>
                    <NoData />
                  </Col>
                </Row>
              )}
              {filteredData && filteredData.length > 0 && (
                <Row gutter={[32, 0]}>
                  {filteredData
                    .slice((currentPage - 1) * pageSize, currentPage * pageSize)
                    .map((data: any, i: number) => (
                      <Col lg={12} style={{ margin: "0.9rem 0" }}>
                        <FinancingCard data={data} />
                      </Col>
                    ))}
                  <Col lg={24} className="invest-sort">
                    <Row justify="space-between">
                      <Col className="first-col"></Col>
                      <Col>
                        <Pagination
                          current={currentPage}
                          pageSize={pageSize}
                          total={filteredData.length}
                          onChange={handlePageChange}
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              )}
            </Col>
          </Row>
        </Col>
      </Row>
      <AppFooter />
    </>
  );
};
